<template>
  <div>
    <div class="card card-video collage-video-item h-100" @click="$emit('select-video', video)">
      <div class="card-img-caption h-100">
        <div class="img-gradient h-100">
          <img class="card-img-top img-video" :class="{'img-video--slim': slimImage}"
               :src="video.image_url">
<!--
          <img class="card-img-top img-video" :class="{'img-video&#45;&#45;slim': slimImage}"
               :src="'https://getpica.s3.amazonaws.com/p/1381/t/ab/fa/abfa4d6a926cb67391efbba459742c8d.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAJOX336QNYQKJ4YLQ%2F20231109%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20231109T101341Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=61d7ca41f5fbdbb5623fc486897ba3d0164b35d2d9a58868a0e0d427e88e9668'">
-->

        </div>
      </div>
      <img class="icon-play position-absolute" src="@/assets/icon-play.svg" height="50">
    </div>
    <div class="video-gallery-item-metadata d-flex justify-content-between mt-2">
      <span class="text-white" v-if="video.duration">{{ video.duration | formatSecondsToHHMMSS }}</span>
    </div>
  </div>
</template>

<script>
import {observeMedia} from "@/utils/media";

export default {
  name: "CollageVideoItem",
  props: {
    video: {
      type: Object,
      required: true
    },
    slimImage: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mounted() {
    this.observeMedia(this.$el, '.collage-video-item', this.video.id, true)
  },
  methods: {
    observeMedia,
  }
}
</script>

<style scoped>

</style>